import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const YouthDevelopmentProgram = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Youth Development Program</h2>
                            <p>
                                The Youth Development Program at Net Nest Badminton Sports Club is specially designed to identify, nurture, and develop young badminton talent at an early age. This program focuses on building a strong foundation in badminton while promoting physical fitness, discipline, confidence, and a lifelong love for the sport.
                            </p>
                            <p>
                                <h2>Program Overview</h2>
                                Our Youth Development Program is ideal for children and young players who are beginning their badminton journey or looking to improve their skills in a structured and supportive environment. The program follows age-appropriate training methods that ensure safe learning, steady progress, and enjoyable participation.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Youth Development Program.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Fundamental Skill Development</h2>
                            <p>
                                Correct grip and stance
                                <br></br>
                                Basic footwork and court movement
                                <br></br>
                                Essential strokes such as clears, drops, and net shots
                                <br></br>
                                Hand-eye coordination and balance
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Age-Appropriate Coaching Approach</h2>
                            <p>
                                Our coaches understand the physical and mental needs of young athletes. Training sessions are designed to be engaging, fun, and educational while maintaining discipline and structure. Exercises and drills are adapted to suit different age groups and skill levels, ensuring effective learning without pressure.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Physical Fitness & Coordination</h2>
                            <p>
                                Agility and speed
                                <br></br>
                                Flexibility and balance
                                <br></br>
                                Strength and endurance
                                <br></br>
                                Overall body coordination
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Mental Development & Discipline</h2>
                            <p>
                                Discipline and time management
                                <br></br>
                                Confidence and self-belief
                                <br></br>
                                Focus and concentration
                                <br></br>
                                Respect for coaches, teammates, and opponents
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Match Exposure & Confidence Building</h2>
                            <p>
                                Friendly practice matches
                                <br></br>
                                Intra-club competitions
                                <br></br>
                                Skill-based challenges
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Talent Identification & Progress Tracking</h2>
                            <p>
                                Our coaches continuously monitor each player’s progress. Talented and committed players are identified early and guided toward advanced training programs. Regular feedback ensures parents are informed about development and future opportunities.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Safe & Supportive Training Environment</h2>
                            <p>
                                At Net Nest Badminton Sports Club, child safety and well-being are our top priorities. We provide a secure, positive, and encouraging atmosphere where young players feel motivated to learn, grow, and enjoy badminton.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Who Can Join the Youth Development Program?</h2>
                            <p>
                                Children and young beginners
                                <br></br>
                                School-level players
                                <br></br>
                                Aspiring young badminton enthusiasts
                                <br></br>
                                Players looking for structured early training
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default YouthDevelopmentProgram;
